import PageLoading from '@/components/page-loading';
import loadable from '@loadable/component';
export default [
    {
        path: '/home/:type?',
        component: loadable(() => import(/* webpackChunkName: "home" */ `@/views/home`), { fallback: <PageLoading /> }),
    },
    {
        path: '/discover/:type?',
        component: loadable(() => import(/* webpackChunkName: "home" */ `@/views/home/components/ApplicationPage`), { fallback: <PageLoading /> }),
    },
] as ReactRoute[];
